module.exports = __webpack_public_path__ + "media/images/gifts/cook/sug_cozinhar_4-b0b3769747905d34cbe93011b4c55265.jpg";